// extracted by mini-css-extract-plugin
export default {"faqs":"FAQs__faqs-EO7O"};